import PropTypes from 'prop-types'
import React, { Component } from 'react'

function getColor(value) {
  if (value > 0 && value < 50) {
    return 'background-green'
  }

  if (value >= 50 && value < 100) {
    return 'background-yellow'
  }

  return 'background-red'
}

// Because <progress> is not supported equally everywhere and styling it is kind of a pain, let's have a small component dealing with this in a simple manner.
class ProgressBar extends Component {
  static propTypes = {
    value: PropTypes.number.isRequired,
    // Used to add extra styles or positionning
    className: PropTypes.string,
  }

  static defaultProps = {
    className: '',
  }

  render() {
    const { value, className = '' } = this.props

    return (
      <div
        style={{ height: 4 }}
        className={`background-shade-40 radius-normal progress-bar-container width-full ${className}`}
      >
        <div
          className={`progress-bar radius-normal height-full ${getColor(
            value
          )}`}
          style={{ width: `${value}%` }}
        />
      </div>
    )
  }
}

export default ProgressBar
